<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button type="primary" class="edit-button" size="mini" @click="select()">刷新</el-button>
        <el-button type="primary" class="edit-button" size="mini" @click="select()">筛选</el-button>
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="width: 44px">买家</label>
          <el-input
            v-model="memberUid"
            placeholder="请输入买家"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 11px;">商品出售码</label>
          <el-input
            v-model="sn"
            placeholder="请输入商品出售码"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1701px"
        size="mini"
      >
        <el-table-column prop="memberUid" label="类型" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.type == 0">普通购买</div>
            <div v-if="scope.row.type == 1">面对面购买</div>
          </template>
        </el-table-column>
        <el-table-column prop="memberUid" label="状态" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">待付款</div>
            <div v-if="scope.row.status == 1">已付款待卖家确认 </div>
            <div v-if="scope.row.status == 2">超时取消</div>
            <div v-if="scope.row.status == 3">卖家确认交易成功</div>
          </template>
        </el-table-column>
        <el-table-column prop="ccSaleSn" label="商品出售码" width="100" />
        <el-table-column prop="name" label="空投包" width="100" />
        <el-table-column prop="saleCount" label="出售数量" width="100" />
        <el-table-column prop="memberUid" label="出售单价" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.price }} {{ scope.row.currency }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="memberUid" label="总价" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.totalPrice }} {{ scope.row.currency }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sellerUid" label="卖家UID" width="100" />
        <el-table-column prop="memberUid" label="买家UID" width="100" />
        <el-table-column prop="myReceiveDate" label="付款截至时间" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.buyerPayDate">{{ happenTimeFun(scope.row.buyerPayDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="myReceiveDate" label="实际付款时间" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.transferDate">{{ happenTimeFun(scope.row.transferDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="withdrawSum" label="配图" width="240">
        <template slot-scope="scoped">
          <div style="display: flex;flex-wrap: wrap;">
              <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" v-for="(item,index) in scoped.row.transferImages" :key="index" fit="fill" :src="item+'?x-oss-process=image/resize,w_50'" :preview-src-list="previewImg(scoped.row.transferImages)" @click.stop="handleClickItem"/>
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="myReceiveDate" label="交易成功时间" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.successDate">{{ happenTimeFun(scope.row.successDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination },
    data() {
      return {
        tableData: [], // 展示的表单信息
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        loading: false, // 表格加载
        dataTime: ["", ""],
        startDate: "",
        endDate: "",
        uid: "",
        options: [],
        subject: "",
        memberUid: "",
        sn: "",
      };
    },
    created() {},
    mounted() {
      this.getList();
      // this.$api.operate
      //   .subjectList()
      //   .then((res) => {
      //     for (let key in res) {
      //       let obj = {}
      //       obj.key = key
      //       obj.value = res[key]
      //       console.log(obj)
      //       this.options.push(obj)
  
      //     }
      //   })
      //   .catch((err) => {
      //     this.$message.error(err || "服务器错误，请稍后重试");
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    methods: {
       previewImg(list){
    let list1 = []
    list.forEach(item => {
      list1.push(item+'?x-oss-process=image/resize,w_450')
    })
    return list1
  },
      happenTimeFun(num) {
        let date = new Date(num);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
      handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
      // 筛选
      select() {
        this.pageNum = 1; 
        this.getList();
      },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          sn: this.sn,
          memberUid: this.memberUid,
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.c2c
          .ccBuyRecord(params)
          .then((res) => {
            this.tableData = res.records;
            this.loading = false;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  // ::v-deep .el-table tr:first-child {
  //   background-color: #edffe4 !important;
  // }
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  .head_search {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
  
    .item_warp {
      display: flex;
  
      .el-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }
  
      label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #525252;
        font-weight: 400;
      }
    }
  }
  </style>
  